<template>
  <div>
    <section class="section-md section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 shape-dark shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pb-150">
        <span>&nbsp;</span>
        <div class="row text-center justify-content-center">
          <div class="col-lg-6">
            <h2 class="display-3 text-white" style="margin-top: 2.5rem">About us</h2>
            <h4 class="text-white">Let's get to know each other!</h4>
          </div>
        </div>
        <div class="text-center">
          <base-button type="primary" class="mt-4 bg-gradient-primary">
            <a href="#/contact-us" class="text-white"> Get in touch! </a>
          </base-button>
        </div>
      </div>
    </section>
    <section class="section section-sm TEAM">
      <div class="container">
        <hr />
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <p class="lead text-muted" style="text-align: justify">
              We are a team of developers who are up to date with the intensive
              development of the IT industry, ready to support you in conducting your
              business with our products, ideas and knowledge. These days the buisness
              development venture is closely related to efficient applications, scalable
              databases and a range of tools to ensure security and quality of service. We
              are available to work with you to create effective and comprehensive
              software solutions through good communication and trust.
            </p>
          </div>
          <div class="col-lg-6">
            <div class="">
              <img
                v-lazy="'./img/ill/duetwoman.png'"
                class="lead shadow"
                width="100%"
                height="auto"
                style="margin-top: 2.5rem"
              />
            </div>
          </div>
        </div>
        <hr />
      </div>
      <div class="container">
        <!-- <div class="row justify-content-center">
          <div class="col">
            <div class="">
              <img
                v-lazy="'./img/ill/team1.png'"
                class="lead img-fluid floating"
                width="auto"
                height="auto"
                style="margin-top: 3rem"
              />
            </div>
            <p class="lead text-muted" style="text-align: justify"></p>
          </div>
        </div> -->
      </div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col">
            <p class="lead text-muted" style="text-align: justify">
              Our team consists of experienced software engineers with a wide range of
              knowledge, for whom it is essential to bet on innovation. We can implement
              different parts of your system, such as back-end, front-end, data modelling,
              scripting, or integration with external services.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="bg-secondary">
      <div class="container pb-150">
        <hr />
        <span>&nbsp;</span>
        <div class="row text-center justify-content-center mb-lg">
          <div class="col-lg-6">
            <h2 class="display-3 text-black">Meet our team</h2>
          </div>
        </div>
        <div class="row">
          <!-- <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 employer1">
            <div class="px-4">
              <img
                v-lazy="'./img/ill/WojtekS.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                style="width: 200px"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <span class="d-block mb-1">Wojciech</span>
                  <small class="h6 text-muted">CEO & Founder</small>
                </h5>
              </div>
            </div>
          </div> -->
          <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 employer2">
            <div class="px-4">
              <img
                v-lazy="'./img/ill/MichalinaW.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                style="width: 200px"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <span class="d-block mb-1">Michalina</span>
                  <small class="h6 text-muted">Founder & Lead Full-stack Engineer</small>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 employer4">
            <div class="px-4">
              <img
                v-lazy="'./img/ill/SebastianW.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                style="width: 200px"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <span class="d-block mb-1">Sebastian</span>
                  <small class="h6 text-muted">Full-stack Engineer</small>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 employer5">
            <div class="px-4">
              <img
                v-lazy="'./img/ill/DominikaS.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                style="width: 200px"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <span class="d-block mb-1">Dominika</span>
                  <small class="h6 text-muted">Backend Engineer</small>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 employer3">
            <div class="px-4">
              <img
                v-lazy="'./img/ill/BeniaminG.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                style="width: 200px"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <span class="d-block mb-1">Beniamin</span>
                  <small class="h6 text-muted">Backend Engineer</small>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 employer3">
            <div class="px-4">
              <img
                v-lazy="'./img/ill/Kometa.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                style="width: 200px"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <span class="d-block mb-1">Michał</span>
                  <small class="h6 text-muted">Backend Engineer</small>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 employer3">
            <div class="px-4">
              <img
                v-lazy="'./img/ill/DariuszL.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                style="width: 200px"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <span class="d-block mb-1">Dariusz</span>
                  <small class="h6 text-muted">Organization Specialist</small>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 employer3">
            <div class="px-4">
              <img
                v-lazy="'./img/ill/RafalG.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                style="width: 200px"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <span class="d-block mb-1">Rafał</span>
                  <small class="h6 text-muted">Backend Engineer</small>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 employer3">
            <div class="px-4">
              <img
                v-lazy="'./img/ill/KacperW.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                style="width: 200px"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <span class="d-block mb-1">Kacper</span>
                  <small class="h6 text-muted">Backend Engineer</small>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Carousel from "./components/Carousel.vue";
import AWS from "aws-sdk";
import "dotenv/config";
export default {
  name: "home",
  components: { Carousel },
  data: function () {
    return {
      message: "",
      name: "",
      email: "",
    };
  },
  methods: {
    scrollToElement(options) {
      const transcriptionSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden"
      )[0];
      if (transcriptionSection) {
        transcriptionSection.scrollIntoView(options);
      }
    },
    scrollToElement1(options1) {
      const matcherSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden matcher"
      )[0];
      if (matcherSection) {
        matcherSection.scrollIntoView(options1);
      }
    },
    scrollToElement2(options2) {
      const teamSection = this.$el.getElementsByClassName("section section-sm TEAM")[0];
      if (teamSection) {
        teamSection.scrollIntoView(options2);
      }
    },
    scrollToElement3(options3) {
      const teamSection = this.$el.getElementsByClassName(
        "section section-sm Technologies"
      )[0];
      if (teamSection) {
        teamSection.scrollIntoView(options3);
      }
    },
    scrollToProducts(options4) {
      const teamSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden PRODUCTS"
      )[0];
      if (teamSection) {
        teamSection.scrollIntoView(options4);
      }
    },
  },
};
</script>
